import React from 'react';
import { DateRange } from 'react-date-range';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { IRangeCalendar } from './types';

const useStyles = makeStyles((theme: Theme) => ({
    calendarWrapper: {
        width: '100%',
        '& .rdrCalendarWrapper': {
            width: '100% !important',
            backgroundColor: theme.palette.background.paper,
        },
        '& .rdrMonth': {
            width: '100% !important',
        },
        '& .rdrDateDisplayWrapper': {
            backgroundColor: theme.palette.background.paper,
        },
        '& .rdrDateInput': {
            backgroundColor: theme.palette.background.paper,
        },
        '& .rdrMonthAndYearPickers': {
            color: '#FFF !important',
        },
        '& .rdrNextPrevButton': {
            backgroundColor: theme.palette.background.paper,
            border: `solid 1px ${theme.palette.primary.main}`,
        },
        '& .rdrPprevButton': {
            backgroundColor: theme.palette.background.paper,
            border: `solid 1px ${theme.palette.primary.main}`,
        },
        '& .rdrMonthPicker > select': {
            color: `${theme.palette.text.primary} !important`,
        },
        '& .rdrYearPicker > select': {
            color: `${theme.palette.text.primary} !important`,
        },
        '& .rdrDateDisplayItem > input::placeholder': {
            color: `${theme.palette.text.primary} !important`,
        },
        '& .rdrWeekDay': {
            color: `${theme.palette.text.primary} !important`,
            fontFamily: theme.typography.fontFamily,
        },
        '& .rdrDays': {
            color: `${theme.palette.text.primary} !important`,
            fontFamily: theme.typography.fontFamily,
        },

        '& .rdrNextPrevButton i': {
            borderColor: `transparent transparent transparent ${theme.palette.primary.main} !important`,
        },
        '& .rdrPprevButton i': {
            borderColor: `transparent ${theme.palette.primary.main} transparent transparent !important`,
        },
    },
}));

/**
 * Represents a date range calendar
 *
 * @param {{
 *     onChange: (value: TRangeValue) => void
 *     value: TRangeValue
 * }} {
 *     onChange,
 *     value,
 * }
 * @return {*}
 */
export const RangeCalendar = ({ ranges, onChange }: IRangeCalendar) => {
    const classes = useStyles();

    return (
        <div
            className={classes.calendarWrapper}
            data-testid="date-range-calendar"
        >
            <DateRange
                editableDateInputs={true}
                onChange={onChange}
                ranges={ranges}
            />
        </div>
    );
};
